import React, {Component} from 'react';
import { BrowserRouter, Routes, Route, Navigate, redirect, Outlet} from "react-router-dom";
import CrearCuenta from "../pages/CrearCuenta";
import Inicio from "../pages/Inicio";
import FirmarDocumentoEspol from '../pages/components/FirmarDocumentoEspol';
import CrearFirma from '../pages/components/RegistroFirma';
import CrearFirmaIframe from '../pages/components/RegistroFirmaIframe';

/*NO BORRAR LOGIN PORQUE ES EL QUE TRAE EL DISE�O DEL FONDO*/
import { Login } from "../pages/Login";
/*fin*/

import FormSolicitud from "../pages/components/FormSolicitud";
import ActualizarArchSolicitud from "../pages/components/ActualizarArchSolicitud";

import FormAcuerdoGeneral from "../pages/components/FormAcuerdoGeneral";
import FormAcuerdoAlumni from "../pages/components/FormAcuerdoAlumni";
import FormAcuerdoAdmisiones from "../pages/components/FormAcuerdoAdmisiones";
import FormAcuerdoUsuariosExternos from "../pages/components/FormAcuerdoUsuariosExternos";

import Acuerdo from "../pages/components/Acuerdo";
/*import VisualizarAcuerdo from "../pages/components/VisualizarAcuerdo";*/
import Visualizarpdf from "../pages/components/Visualizarpdf";
import CambiarContrasenia from "../pages/CambiarContrasenia";
import CambiarContraseniaRedirect from "../pages/CambiarContraseniaRedirect";
import OlvidoContrasenia from "../pages/OlvidoContrasenia";
import LoginExt from "../pages/LoginExt";
import LoginCCex from "../pages/LoginCcex";
import PuenteLogin from "../pages/PuenteLogin";
import Logout from "../pages/Logout";

import AdminUsuarios from "../pages/AdminUsuarios";
import PruebaCamara from "../pages/PruebaCamara";
import AdminGrupos from "../pages/AdminGrupos";
import AdminSolicitudes from "../pages/AdminSolicitudes";
import AdminHabilitarFirmas from "../pages/AdminHabilitarFirmas";
import PrivateRoute from "./PrivateRoute";
import PrivateHome from "./PrivateHome";
import Cookies from 'js-cookie';
import FormCambiarContrasenia from '../pages/components/FormCambiarContrasenia';
//import PageView from '../pages/components/PageView';

import Admin from "./Admin";
import jwt from 'jwt-decode'
import Renderpdf from "../pages/components/renderPDF";
import ProtectedRouteEntraID from './ProtectedRouteEntraID'; // <-- Importamos el nuevo componente
import ProtectedRouteEntraIDCcex from './ProtectedRouteEntraIDCcex'; // <-- Importamos el nuevo componente
import SignupForm from '../pages/components/SignupForm';

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from '../authConfig';
import { msalConfigCcex } from '../authConfigCcex';

import LoginGoogle from '../pages/LoginGoogle';
import GoogleCallback from '../pages/GoogleCallback';

const pcaEspol = new PublicClientApplication(msalConfig);
const pcaCcex = new PublicClientApplication(msalConfigCcex);

//intentemos hacerlo clase y pasar desde el una variable auth boolean
//para cambiar su estado en Login, y usarlo en las Private

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isAuth: false,
        isLogin:false
    };
    this.setAuth = this.setAuth.bind(this);
    this.setIsLogin = this.setIsLogin.bind(this);

  }

    setAuth(valor) {
        this.setState({ isAuth: valor });
    }

    setIsLogin(valor) {
        this.setState({ isLogin: valor },()=>{
            //console.log(this.state.isLogin);
        });
    }

    readCookie(){
        if (Cookies.get("token") !== undefined) {
            var token = Cookies.get("token");
            var tokendecode = jwt(token);
            var admin = tokendecode["Rol"];
            if (admin === "Admin") {
                this.setAuth(true);
            }
            //alert("Desde el apps: "+ this.state.isAuth);
        }
    }
  
    componentDidMount(){
        this.readCookie();
    }


    callTagManager(nombre_evento) {
        //console.log(nombre_evento);
        window.dataLayer.push({
            event: nombre_evento,
        });
    }

    useEffect = () => {
        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        }
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHAKEY}`, function () {});      
    };

 render() {
   // console.log("state isAuth: " + this.state.isLogin);
    
    return (
        <BrowserRouter>

            <MsalProvider instance={pcaCcex}>
                <Routes>
                    <Route element={<ProtectedRouteEntraIDCcex isAuth={this.state.isAuth} setIsLogin={this.setIsLogin} />}>
                        <Route path="/loginmicrosoft" element={<LoginCCex />} />
                        <Route path="/cambiarcontraseniaext" element={<FormCambiarContrasenia isAuth={this.state.isAuth} callTagManager={this.callTagManager} isLogin={this.state.isLogin} />} />
                    </Route>

                    <Route path="/loginGoogle" element={<LoginGoogle />} />
                    <Route path="/oauth2/callback/google" element={<GoogleCallback />} />
                </Routes>
            </MsalProvider>

            <Routes>
                <Route path="/inicio" element={<Outlet />}>
                    <Route path="/inicio" element={<Inicio setValue={this.setAuth} />} />
                </Route>
                <Route index element={<Navigate to="/inicio" replace />} />
                
                <Route path="/" element={<ProtectedRouteEntraID  isAuth={this.state.isAuth} setIsLogin={this.setIsLogin} />}>

                    <Route path="/usuarios" element={<AdminUsuarios setValue={this.setAuth} isLogin={this.state.isLogin} />} />
                    <Route path="/grupos" element={<AdminGrupos setValue={this.setAuth}/>} />
                    <Route path="/solicitudes" element={<AdminSolicitudes setValue={this.setAuth} />} />.
                    <Route path="/habilitarfirmas" element={<AdminHabilitarFirmas setValue={this.setAuth} />} />.

                    <Route path="/cambiarcontrasenia" element={<FormCambiarContrasenia isAuth={this.state.isAuth} callTagManager={this.callTagManager}  isLogin={this.state.isLogin}/>} />
                    <Route path="/acuerdogeneral" element={<FormAcuerdoGeneral  />} />
                    <Route path="/crearfirma" element={<CrearFirma />} />
                    <Route path="/firmardocumento" element={<FirmarDocumentoEspol />} />
                    <Route path="/crearfirmaespol" element={<CrearFirmaIframe />} />
                </Route>
                {/*Navigate al CASadmin*/}
                <Route path="/admin" element={<Admin />} />
                <Route path="/registro" element={<CrearCuenta callTagManager={this.callTagManager} useEffect={this.useEffect} />} />
                <Route path="/solicitud" element={<SignupForm callTagManager={this.callTagManager} useEffect={this.useEffect}/>} />
                <Route path="/cambiarcontraseniaredirect" element={<CambiarContraseniaRedirect callTagManager={this.callTagManager} />} />
                <Route path="/olvidoContrasenia" element={<OlvidoContrasenia callTagManager={this.callTagManager} />} />
                <Route path="/logout" element={<Logout />} />

                <Route path="/acuerdoalumni" element={<FormAcuerdoAlumni /*useEffect={this.useEffect}*/ />}  />
                <Route path="/rectificaciondocs" element={<ActualizarArchSolicitud callTagManager={this.callTagManager} /*useEffect={this.useEffect}*/ />} />
                <Route path="/acuerdoadmisiones" element={<FormAcuerdoAdmisiones /*useEffect={this.useEffect}*/ />} />
                <Route path="/acuerdoexternos" element={<FormAcuerdoUsuariosExternos useEffect={this.useEffect} />} />

                
                {/* <Route path="/solicitud" element={<FormSolicitud callTagManager={this.callTagManager} />} />*/}
                {/*<Route path="/CambiarContrasenia" element={<CambiarContrasenia />} />*/}
                {/*<Route path="/Visualizarpdf" element={<Visualizarpdf />} />*/}
                {/*<Route path="/PruebaCamara" element={<PruebaCamara />} /> */}
                {/*<Route path="/Acuerdo" element={<Acuerdo />} */}
                

            </Routes>
      </BrowserRouter>

    );
  }
}

